import React, { useState } from "react";
import { Table, Form, Button } from "antd";
import moment from "moment";

import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useRouteMatch,
  useParams,
  NavLink,
  useHistory,
  useLocation,
} from "react-router-dom";

import {
  getColumnSearchProps,
  generateFilterSet,
  generateBooleanColumnSet,
} from "../../../search.js";
import ContentTitlesList from "./index.js";
import Text from "antd/lib/typography/Text";

const ContentTitlesTable = (props) => {
  console.log(process.env);

  const [form] = Form.useForm();
  const { incompleteBundlesData, isContentTitlesLoaded } = props;

  const [searchInput, setSearchInput] = useState("");
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState(null);

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };

  const generateColumnSearchFunctions = (dataIndex) => ({
    dataIndex: dataIndex,
    handleSearch: handleSearch,
    handleReset: handleReset,
    searchedColumn,
    searchText,
    setSearchInput: setSearchInput,
    searchInput: searchInput,
  });

  const columns = [
    {
      key: "BundleID",
      dataIndex: "BundleID",
      title: "Job ID",
      ...getColumnSearchProps(generateColumnSearchFunctions("BundleID")),
    },
    {
      key: "Title",
      title: "First Input File Name",
      dataIndex: "Title",
      ...getColumnSearchProps(generateColumnSearchFunctions("Title")),
    },
    {
      key: "ContentType",
      dataIndex: "ContentType",
      title: "Content Type",
      // ...getColumnSearchProps(generateColumnSearchFunctions("ContentType")),
      // filters: [
      //   { text: "Series", value: "series" },
      //   { text: "Movie", value: "movie" },
      // ],
      // filterMultiple: true,
      // onFilter: (value, record) => value == record.ContentType,
      ...generateFilterSet(incompleteBundlesData, "ContentType", true),
    },
    {
      key: "submit_time",
      dataIndex: "submit_time",
      title: "Submit Time",
      render: (datum) => (
        <Text> {moment().format("MM/DD/YYYY HH:mm:ss Z")}</Text>
      ),
    },
    {
      key: "finish_time",
      dataIndex: "finish_time",
      title: "Finish Time",
      render: (datum) => (
        <Text> {moment().format("MM/DD/YYYY HH:mm:ss Z")}</Text>
      ),
    },
    {
      key: "Status",
      dataIndex: "Status",
      title: "Status",
      render: (datum) => <Text>Complete</Text>,
    },
    {
      key: "Queue",
      title: "Queue",
      render: (datum) => <Text>default</Text>,
    },
    // {
    //   key: "Resolution",
    //   dataIndex: "Resolution",
    //   title: "Resolution",
    //   ...getColumnSearchProps(generateColumnSearchFunctions("Resolution")),
    // },
    // {
    //   key: "serviceArea",
    //   dataIndex: "serviceArea",
    //   title: "Service Area",
    //   filters: [...new Set(incompleteBundlesData.map((hub) => hub.cellId))]
    //     .sort()
    //     .map((cellId) => ({
    //       text: cellId,
    //       value: cellId,
    //     })),
    //   filterMultiple: true,
    //   onFilter: (value, record) => record.cellId === value,
    // },
    // {
    // {
    //   key: "master_delivery_schedule",
    //   title: "Master Delivery Schedule",
    //   render: (datum) => (
    //     <Link to={`delivery/hub/${encodeURI(datum.hubId)}/master_schedule`}>
    //       <Button type="primary">Master Schedule</Button>
    //     </Link>
    //   ),
    // },
  ];
  return (
    <Form form={form} component={false}>
      <Table
        loading={!isContentTitlesLoaded}
        columns={columns}
        dataSource={incompleteBundlesData}
        bordered
        pagination={false}
        rowClassName="editable-row"
      />
    </Form>
  );
};

export default ContentTitlesTable;
